// extracted by mini-css-extract-plugin
module.exports = {"paidPlaces":"_7b950cc","label":"_8088a18","value":"_2600430"};